import { FC, useEffect, useState } from 'react'
import VocabularyApi from '../../../../infrastructure/api/VocabularyApi'
import { IVocabularyModel } from '../../../../models/responses/VocabularyModel'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { LanguageEnum } from '../../../../enums/LanguageEnum'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const VocabularyListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [vocabularies, setVocabularies] = useState<PagedResponseModel<IVocabularyModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('word_asc')

  useEffect(() => {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }
    async function getVocabularies() {
      var response = await VocabularyApi.GetVocabularies(paginationFilter)
      setVocabularies(response.data)
    }
    getVocabularies()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='Vocabularies'
        data={vocabularies?.items}
        currentTotalRecords={vocabularies?.totalRecords!!}
        currentPageNumber={vocabularies?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false,
            },
          },
          {
            label: 'Word',
            name: 'word',
            options: {
              customBodyRender: (value) => {
                return <b>{value}</b>
              },
            },
          },
          {
            label: 'Language',
            name: 'languageId',
            options: {
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{LanguageEnum[value]}</div>
              },
            },
          },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={vocabularies?.items[dataIndex]?.id!!}
                    itemParam={vocabularies?.items[dataIndex]?.word!!}
                    links={[
                      { type: 'edit', value: '/topic/vocabularies/edit/' + vocabularies?.items[dataIndex]?.id!! }
                    ]}
                    types={[TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { VocabularyListModal }
